import React from "react";
import { useTranslation } from "react-i18next";

import { Banner } from "fe-shared/src/components";
import { Address } from "fe-shared-transactions/src/types";
import { getFullAddress } from "fe-shared-transactions/src/helpers/address";

import styles from "../EditInventoryAdjustmentDialog.module.scss";

interface Props {
  address?: Address;
  companyRegNumber: number;
  companyDisplayName: string;
}

const InfoSection = ({
  address,
  companyRegNumber,
  companyDisplayName,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.info}>
      <div className={styles.infoParticipant}>
        <span className={styles.infoParticipantName}>{companyDisplayName}</span>
        <span className={styles.infoParticipantRegNumber}>
          {companyRegNumber}
        </span>
      </div>
      <div className={styles.infoStorage}>
        <div className={styles.title}>
          {t("inventoryAdjustment.details.storageYard")}
        </div>

        {!!address && (
          <div className={styles.infoStorageAddress}>
            {getFullAddress(address)}
          </div>
        )}
      </div>
      <Banner
        id="create-inventory-adjustment-banner"
        variant="info"
        className={styles.infoBanner}
        title={t("inventoryAdjustment.details.edit.dialog.bannerTitle")}
      >
        <p>{t("inventoryAdjustment.details.edit.dialog.bannerNegativeInfo")}</p>
        <p>{t("inventoryAdjustment.details.edit.dialog.bannerPositiveInfo")}</p>
      </Banner>
    </div>
  );
};

export default InfoSection;
